import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ExternalTokensService } from '@services/external-tokens/external-tokens.service';
import { DataTableComponent, DataTableEvent } from '../../components/data-table/data-table.component';
import { PageAction } from '../../components/page-actions/page-actions.component';
import { DialogService } from '@services/dialog/dialog.service';

@Component({
    selector: 'app-external-tokens',
    templateUrl: './external-tokens.component.html',
    styleUrls: ['./external-tokens.component.scss'],
    providers: [ExternalTokensService, DialogService],
    standalone: false
})
export class ExternalTokensComponent implements OnInit {

  pageActions: PageAction[];

  @ViewChild(DataTableComponent) dataTable: DataTableComponent;

  columns = [{ prop: 'title', name: 'Title' }, { prop: 'email', name: 'E-Mail' }];

  dataProviderParams = {};

  constructor(public externalTokenService: ExternalTokensService, private router: Router, private dialogService: DialogService) {
  }

  ngOnInit() {
    this.createPageActions();
  }

  onEdit(event: DataTableEvent): void {
    this.router.navigate(['external-tokens', event.row._id, 'edit']);
  }

  onRemove(event: DataTableEvent): void {
    this.dialogService
      .confirm('Remove External Token?')
      .then(res => {
        if (!res) {
          return;
        }
        return this.externalTokenService.remove(event.row._id).then(() => {
          this.dataTable.refresh();
        }).catch(error => {
          console.log(error);
          const message = (error.error.message ? error.error.message : error.message);
          return this.dialogService.confirm(message, error.name);
        });
      });
  }

  createPageActions() {
    this.pageActions = [
      new PageAction({
        icon: 'create',
        title: 'Create External Token',
        callback: () => {
          this.router.navigate(['external-tokens/create']);
        }
      })
    ];
  }

}
